import { RegisterPage } from './RegisterPage';

export { RegisterPage };
export default RegisterPage;
